const LOGIN_SHEET_URL =
  "https://script.google.com/macros/s/AKfycbwtUJ3_41QGNZLi3QIJ2QJvTe7TtU0b2Hqc-drL_h6FNeH9-4nrPRql6AlB6lUzDFJF/exec";



export const login = async (email, password) => {
  try {
    const response = await fetch(LOGIN_SHEET_URL);
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const result = await response.json();
    console.log('Login result from Account service:', result);
    
    if (result.status === 'success' && result.data) {
      const user = result.data.find(u => u.email === email);
      
      if (!user) {
        return { 
          success: false, 
          error: 'Invalid email or password'
        };
      }

      // Here we should also validate password, but for now just check email
      localStorage.setItem('user', JSON.stringify(user));
      
      return { 
        success: true, 
        user,
        message: 'Login successful!'
      };
    }
    
    return { 
      success: false, 
      error: 'Invalid email or password'
    };
  } catch (error) {
    console.error('Login error:', error);
    return { 
      success: false, 
      error: 'Login failed. Please try again.'
    };
  }
};

export const createUser = async (userData) => {
  try {
    const response = await fetch(LOGIN_SHEET_URL, {
      method: "POST",
      body: JSON.stringify({
        operation: "create",
        ...userData,
      }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const result = await response.json();
    return {
      success: result.status === "success",
      message: result.message,
      error: result.status === "error" ? result.message : null,
    };
  } catch (error) {
    console.error("Create user error:", error);
    return {
      success: false,
      error: "Failed to create user",
    };
  }
};

export const logout = () => {
  localStorage.removeItem("user");
};

export const checkAuthStatus = () => {
  const user = localStorage.getItem("user");
  if (!user) return { isAuthenticated: false };

  return {
    isAuthenticated: true,
    user: JSON.parse(user),
  };
};

export const resetPassword = async (email, newPassword) => {
  try {
    const response = await fetch(LOGIN_SHEET_URL, {
      method: "POST",
      body: JSON.stringify({
        operation: "resetPassword",
        email,
        newPassword,
      }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const result = await response.json();

    return {
      success: result.status === "success",
      message: result.message,
      error: result.status === "error" ? result.message : null,
    };
  } catch (error) {
    console.error("Password reset error:", error);
    return {
      success: false,
      error: "Failed to reset password",
    };
  }
};
